import { HorizontalSafeAreaContainer } from '../../../../../components';
import { OrderProductConfirmLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <OrderProductConfirmLocationScreen />
    </HorizontalSafeAreaContainer>
  );
}
